
import React from "react";


const ads = [
    {
      title: "2025_04_Tusker_RM_FP_Standard_300x250_v1_300x250",
      id: 1547295,
      dimensions: "300x250",
      width: 300,
      height: 250,
      videoSrc:
        "https://dsp.eskimi.com/files/upload/rm/upload/683574877ebfd/Standard_300x250_v1/assets/vid.mp4",
    },
    {
      title: "2025_04_Tusker_RM_FP_Standard_300x600_v1_300x600",
      id: 1547296,
      dimensions: "300x600",
      width: 300,
      height: 600,
      videoSrc:
        "https://dsp.eskimi.com/files/upload/rm/upload/68357488ccd47/Standard_300x600_v1/assets/vid.mp4",
    },
    {
      title: "2025_04_Tusker_RM_FP_Standard_320x480_v1_320x480",
      id: 1547297,
      dimensions: "320x480",
      width: 320,
      height: 480,
      videoSrc:
        "https://dsp.eskimi.com/files/upload/rm/upload/68357489b22c0/Standard_320x480_v1/assets/vid.mp4",
    },
  ];
  
  const TuskerDetail = () => {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8 space-y-10 mt-14">
        <h3 className="text-xl font-bold text-black">
          Eskimi DSP 2025_04_Tusker_RM_FP (ID: 236159) campaign preview
        </h3>
  
        {ads.map((ad) => (
          <div key={ad.id} className="space-y-2">
            <h4 className="font-semibold text-sm sm:text-base text-black">
              {ad.title} (ID: {ad.id})
            </h4>
            <div
              className="overflow-hidden rounded border border-gray-300"
              style={{ width: ad.width, height: ad.height }}
            >
              <video
                src={ad.videoSrc}
                autoPlay
                muted
                loop
                playsInline
                width={ad.width}
                height={ad.height}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-xs text-gray-600">({ad.dimensions})</p>
          </div>
        ))}
      </div>
  );
};

export default TuskerDetail;


// import React, { useEffect } from "react";

// const adData = [
//   {
//     title: "2025_04_Tusker_RM_FP_Standard_300x250_v1_300x250",
//     id: "xt-8c3d6f92-b494-442a-92bb-c53563312d12",
//     width: 300,
//     height: 250,
//     campaignId: 236159,
//     creativeId: 1547295,
//     baseUrl:
//       "https://dsp.eskimi.com/files/upload/rm/upload/683574877ebfd/Standard_300x250_v1/",
//     js: "2_1536436835748c36fc3_450215437.js",
//     code: "code.js",
//     summary: "(300x250)",
//   },
//   {
//     title: "2025_04_Tusker_RM_FP_Standard_300x600_v1_300x600",
//     id: "xt-c1961d2e-44f4-4a33-b97c-cda516603327",
//     width: 300,
//     height: 600,
//     campaignId: 236159,
//     creativeId: 1547296,
//     baseUrl:
//       "https://dsp.eskimi.com/files/upload/rm/upload/68357488ccd47/Standard_300x600_v1/",
//     js: "2_1536436835748c56d39_450215437.js",
//     code: "code.js",
//     summary: "(300x600)",
//   },
//   {
//     title: "2025_04_Tusker_RM_FP_Standard_320x480_v1_320x480",
//     id: "xt-24f202fd-ee7c-4703-83da-c2f5043ebc1c",
//     width: 320,
//     height: 480,
//     campaignId: 236159,
//     creativeId: 1547297,
//     baseUrl:
//       "https://dsp.eskimi.com/files/upload/rm/upload/68357489b22c0/Standard_320x480_v1/",
//     js: "2_1536436835748c77853_450215437.js",
//     code: "code.js",
//     summary: "(320x480)",
//   },
// ];

// const TuskerDetail = () => {
//   useEffect(() => {
//     adData.forEach((ad) => {
//       const iframe = document.getElementById(ad.id);
//       if (iframe) {
//         const ifd =
//           iframe.contentDocument ||
//           (iframe.contentWindow && iframe.contentWindow.document);
//         if (ifd) {
//           ifd.open("text/html", "replace");
//           ifd.write(`<!DOCTYPE html>
// <html lang="en">
// <head>
//   <script>
//     var __eventUrl = "https://dsp-ap.eskimi.com/event/pixel?typeCat=event&test=1&type=";
//     var __clickUrl = "https://dsp-trk.eskimi.com/click?test=${ad.campaignId}&chk=0&crid=${ad.creativeId}&c=";
//   </script>
//   <base href="${ad.baseUrl}" target="_blank">
//   <meta charset="UTF-8">
//   <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">
//   <meta name="ad.size" content="width=${ad.width},height=${ad.height}">
//   <meta name="x-rm-alias" content="tracker_FP-AT">
//   <link rel="stylesheet" href="${ad.baseUrl}css/style.css">
//   <script src="${ad.baseUrl}js/gsap.min.js"></script>
//   <script src="${ad.baseUrl}js/eskimi_rm.min.js"></script>
//   <style>html, body { margin: 0; padding: 0; }</style>
// </head>
// <body class="inner-page">
//   <div id="adsArea">
//     <div class="wrapper">
//       <div class="bg"></div>
//       <video class="vid" src="${ad.baseUrl}assets/vid.mp4#t=0.01" playsinline muted></video>
//     </div>
//     <script src="https://dsp.eskimi.com/files/upload/js/${ad.js}?_=${Date.now()}"></script>
//     <script src="${ad.baseUrl}js/${ad.code}"></script>
//   </div>
// </body>
// </html>`);
//           ifd.close();
//         }
//       }
//     });
//   }, []);

//   return (
//     <div className="p-4 max-w-screen-xl mx-auto space-y-10">
//       <h3 className="text-xl font-semibold text-gray-800">
//         Eskimi DSP 2025_04_Tusker_RM_FP (ID: 236159) campaign preview
//       </h3>
//       {adData.map((ad, idx) => (
//         <div key={ad.id} className="space-y-2">
//           <b className="block text-sm md:text-base text-gray-700">{ad.title} (ID: {ad.creativeId})</b>
//           <div className="border rounded-md shadow overflow-hidden max-w-full">
//             <iframe
//               id={ad.id}
//               width={ad.width}
//               height={ad.height}
//               scrolling="no"
//               frameBorder="0"
//               className="w-full"
//             ></iframe>
//           </div>
//           <div className="text-sm text-gray-500">{ad.summary}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default TuskerDetail;
